<template>
  <div class="mb-3">
    <div class="row mb-3">
        <div class="col myNumber">
            <div class="accentBox">
                <div class="Mypagetop_accentBox__headings">会員番号</div>
                <div class="accentBox__content">{{ member_no }}</div>
            </div>
        </div>
    </div>
    <div class="row ml-2">
        <h5 class="col font-weight-bold">{{ full_name }}&nbsp;&nbsp;様</h5>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    member_no: {
      type: String,
      // 必須
      required: true,
    },
    full_name: {
      type: String,
      // 必須
      required: true,
    }
  }
}
</script>